import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, scheduleId) => {
  const endpoint = URLS.reports.schedule(scheduleId);
  return httpClient.get(endpoint).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.REPORTS_SCHEDULE', handler, { defaultKey: 1 });
